// extracted by mini-css-extract-plugin
export default {"IconSelector-Icon":"IconSelector-Icon1y3cCIHSE0Xc"};